import { Component, h } from 'preact';

interface Props {
  style?: any;
  contextRef: (
    context: CanvasRenderingContext2D,
    canvas: HTMLCanvasElement
  ) => void;
}

class PureCanvas extends Component<Props> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <canvas
        style={this.props.style}
        ref={canvas =>
          canvas ? this.props.contextRef(canvas.getContext('2d'), canvas) : null
        }
      />
    );
  }
}

PureCanvas.defaultProps = {
  style: {},
};

export default PureCanvas;
